<template>
    <div v-if="socialMediaItems.length" class="flex items-center">
        <template v-for="(item, socialMediaIndex) in socialMediaItems" :key="'social-media-' + socialMediaIndex">
			<a :href="item.url" target="_blank" rel="nofollow noopener" :aria-label="item.name" :title="item.name" class="text-2xl text-gray-400" :class="{'ml-8': socialMediaIndex !== 0, 'mr-8': socialMediaIndex !== socialMediaItems.length - 1}">
				<icon v-if="item.icon" large :icon="item.icon" :color="item.color"/>
				<cdn-image v-else-if="item.image" :src="item.image.path" :height="24" :ratio="item.image.ratio"/>
			</a>
        </template>
    </div>
</template>

<script setup lang="ts">
	import {computed} from 'vue';
	import {useSocialMedia} from "#imports";
	import type {SocialMediaType} from "../../types";

	const props = defineProps<{
		socialMedia: {
			[key in SocialMediaType]?: string;
		};
	}>();

	const {config: socialMediaConfig} = useSocialMedia();

	const socialMediaItems = computed(() => {
		return Object.keys(props.socialMedia).map((type) => {
			return {
				type,
				url: props.socialMedia[type],
				...socialMediaConfig[type]
			}
		});
	});
</script>